import $ from "cash-dom"
import React from "react"
import {createRoot} from "react-dom/client"
import ModalProvider from "../modal_provider"
import QuizModeSelectorModal from
    "../components/quiz_mode_selector/quiz_mode_selector_modal"

const container_id = "quiz_mode_selector_modal_container"

function init_quiz_mode_selector_modal(quiz_slug, selection, modal_options) {
  const container =
    document.getElementById(container_id) || create_react_container()
  const root = createRoot(container)

  return new Promise((resolve, reject) => {
    root.render(
      <ModalProvider>
        <QuizModeSelectorModal
          is_open={true}
          quiz_slug={quiz_slug}
          custom_quiz_selection={selection}
          on_close={() => root.unmount()}
          on_loading_error={reject}
          on_loading_success={resolve}
          {...modal_options}
        />
      </ModalProvider>
    )
  })
}

function create_react_container() {
  $("body").append(`<div id="${container_id}"></div>`)
  return document.getElementById(container_id)
}

export default init_quiz_mode_selector_modal
